import React from 'react';
import closeIcon from '../images/close popup.png';


const PopUpWithHeader = ({innerClass, title, children, close = () => {}}) => (
    <div className='popup-warning'>
        <div className={innerClass}>
            <div className='project-edit-title-container'>
                <div className='project-edit-with-close'>
                    <p className='project-edit-p'>{title}</p>
                    <img className='project-edit-close' src={closeIcon} alt='close popup' onClick={close}/>
                </div>
            </div>
            {children}
        </div>
    </div>
);

export default PopUpWithHeader;
